import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import bannerSlice from "./slices/bannerSlice";
import categorySlice from "./slices/categorySlice";
import contactSlice from "./slices/contactSlice";
import informationSlice from "./slices/informationSlice";
import schoolHistorySlice from "./slices/schoolHistorySlice";
import visionMissionSlice from "./slices/visionMissionSlice";
import schoolFacilitySlice from "./slices/schoolFacilitySlice";
import activityGallerySlice from "./slices/activityGallerySlice";
import testimonialSlice from "./slices/testimonialSlice";
import ppdbSlice from "./slices/ppdbSlice";
import programSlice from "./slices/programSlice";
import organizationSlice from "./slices/organizationSlice";
import navbarLinkSlice from "./slices/navbarLinkSlice";
import extracurricularSlice from "./slices/extracurricularSlice";
import userSlice from "./slices/userSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    banner: bannerSlice,
    category: categorySlice,
    contact: contactSlice,
    information: informationSlice,
    schoolHistory: schoolHistorySlice,
    visionMission: visionMissionSlice,
    schoolFacility: schoolFacilitySlice,
    activityGallery: activityGallerySlice,
    testimonial: testimonialSlice,
    ppdb: ppdbSlice,
    program: programSlice,
    organization: organizationSlice,
    navbarLink: navbarLinkSlice,
    extracurricular: extracurricularSlice,
    user: userSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
